export const ERASE_BASE_COLOR = "rgba(255, 0, 0, 1)";
export const BRUSH_BASE_COLOR = "rgba(0, 255, 0, 1)";
export const ERASE_COLOR = [194, 35, 38];
export const BRUSH_COLOR = [76, 255, 206];